import React from "react";
import SecondaryHeader from "../../components/common/SecondaryHeader";

const About = () => {
  const features = [
    {
      icon: "🏠",
      title: "Premium Properties",
      description:
        "Handpicked selection of luxury homes and apartments in prime locations",
    },
    {
      icon: "💰",
      title: "Best Price Guarantee",
      description:
        "We ensure you get the best value for your investment with our price match policy",
    },
    {
      icon: "🔍",
      title: "Virtual Tours",
      description:
        "Explore properties from the comfort of your home with our 360° virtual tours",
    },
    {
      icon: "📞",
      title: "24/7 Support",
      description:
        "Our dedicated team is always available to assist you with your property journey",
    },
    {
      icon: "⚖️",
      title: "Legal Assistance",
      description:
        "Complete legal support and documentation for hassle-free property transactions",
    },
    {
      icon: "📈",
      title: "Market Insights",
      description:
        "Expert analysis and market trends to help you make informed decisions",
    },
  ];

  const partners = [
    { name: "Construction Pro", logo: "🏗️" },
    { name: "Elite Builders", logo: "🏢" },
    { name: "Urban Developers", logo: "🌆" },
    { name: "Prime Properties", logo: "🔑" },
    { name: "Luxury Homes", logo: "💎" },
    { name: "Smart Living", logo: "🤖" },
  ];

  return (
    <div className="min-h-screen">
      <SecondaryHeader
        pageHeading="About Us"
        breadcomb={<span>Home / About</span>}
      />

      {/* Introduction Section */}
      <section className="py-8 bg-gradient-to-br from-gray-50 to-blue-50">
        <div className="px-6 xl:px-20 py-12 bg-gray-50">
          {/* Heading */}
          <div className="text-center mb-12">
            <h1 className="xl:text-4xl sm:text-3xl text-2xl font-bold text-gray-900">
              Welcome to Sekhar Builders & Promoters
            </h1>
            <div className="w-28 h-1.5 bg-yellow-400 mx-auto mt-4"></div>
          </div>

          {/* Main Intro Section */}
          <div className="bg-white rounded-3xl shadow-lg p-8 md:p-12">
            <h2 className="text-3xl font-bold text-gray-800 mb-6">
              Our Introduction
            </h2>

            <div className="space-y-5 text-lg leading-relaxed text-gray-700">
              <p>
                Sekhar Builders & Promoters Pvt. Ltd. is a premier commercial
                construction company having a reputation of quality
                craftsmanship and expertise throughout Odisha. The directors of
                the company have vast experience of more than 15 years in the
                field of building construction at competitive price under the
                guidance of the team of experienced and professional Architects
                and Engineers.
              </p>

              <p>
                We are one of the leading private sector construction companies
                in Odisha & developing new age construction technologies. The
                project teams maintain a strong foundation of trusts and mutual
                respects generated through positive relationships with Clients,
                Architects, Engineers, Contractors and Suppliers. Our value
                comes from our employees and our resources. Our employees are
                the best the industry has to offer. They are selected for their
                attitudes and aptitudes.
              </p>

              <p>
                We have worked among the designers, suppliers, building
                officials, and subcontractors for years. All the projects come
                with ample greenery, spacious and modern design.
              </p>
            </div>
          </div>

          {/* Highlight Cards */}
          <div className="grid md:grid-cols-2 gap-10 mt-12">
            {/* Card 1 */}
            <div className="bg-white p-8 rounded-2xl shadow-md border border-gray-100 hover:shadow-lg transition-all">
              <h3 className="text-2xl font-semibold text-gray-800 mb-4 flex items-center">
                <span className="text-blue-500 text-3xl mr-3">⭐</span> Industry
                Leadership
              </h3>
              <p className="text-gray-700 leading-relaxed">
                We are one of the leading private sector construction companies
                in Odisha, developing modern-age construction technologies. Our
                team maintains strong trust and professional relationships with
                clients, architects, contractors, engineers, and suppliers —
                forming the backbone of our success.
              </p>
            </div>

            {/* Card 2 */}
            <div className="bg-white p-8 rounded-2xl shadow-md border border-gray-100 hover:shadow-lg transition-all">
              <h3 className="text-2xl font-semibold text-gray-800 mb-4 flex items-center">
                <span className="text-yellow-500 text-3xl mr-3">👥</span> Our
                Greatest Asset
              </h3>
              <p className="text-gray-700 leading-relaxed">
                Our employees are our greatest strength. Selected for their
                skills, attitudes, and technical expertise, they bring
                innovation and dedication to every project we build.
              </p>
            </div>
          </div>

          {/* Bottom Highlight */}
          <div className="mt-14">
            <div className="bg-gradient-to-r from-blue-50 to-yellow-50 p-10 rounded-3xl shadow-inner">
              <h3 className="text-3xl font-bold text-center text-gray-800 mb-5">
                Premier Construction Excellence
              </h3>
              <p className="text-lg text-gray-700 leading-relaxed text-center max-w-4xl mx-auto">
                <strong>Sekhar Builders & Promoters Pvt. Ltd.</strong> stands at
                the forefront of Odisha’s construction industry, backed by more
                than <strong>15 years of excellence</strong> in creating
                high-quality, modern-building projects crafted under expert
                architectural and engineering guidance.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Mission & Vision Section */}
      <section className="py-8 bg-white">
        <div className="px-6 xl:px-20">
          <div className="grid md:grid-cols-2 gap-10 items-stretch">
            {/* Mission */}
            <div className="text-center transition-transform group divide-neutral-400 md:text-left shadow-lg p-5 rounded-2xl">
              <div className="bg-blue-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto md:mx-0 xl:mb-6 mb-4">
                <span className="text-2xl">🎯</span>
              </div>
              <h2 className="text-3xl group-hover:text-[#e4e95b] transition-colors duration-300 font-bold text-gray-800 xl:mb-6 mb-4">
                Our Mission
              </h2>
              <p className="text-lg text-gray-600 leading-relaxed mb-4">
                To simplify the real estate journey by providing transparent,
                personalized, and comprehensive property solutions that exceed
                our clients' expectations.
              </p>
              <p className="text-lg text-gray-600 leading-relaxed">
                We believe everyone deserves a place they can truly call home,
                and we're dedicated to making that dream a reality.
              </p>
            </div>

            {/* Vision */}
            <div className="text-center transition-transform group divide-neutral-400 md:text-left shadow-lg p-5 rounded-2xl">
              <div className="bg-purple-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto md:mx-0 xl:mb-6 mb-4">
                <span className="text-2xl">🔭</span>
              </div>
              <h2 className="text-3xl group-hover:text-[#e4e95b] transition-colors duration-300 font-bold text-gray-800 xl:mb-6 mb-4">
                Our Vision
              </h2>
              <p className="text-lg text-gray-600 leading-relaxed mb-4">
                To become the most trusted real estate partner, revolutionizing
                the industry through innovation, integrity, and exceptional
                service.
              </p>
              <p className="text-lg text-gray-600 leading-relaxed">
                We envision a future where finding your perfect home is
                seamless, secure, and satisfying.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-8">
        <div className="px-6 xl:px-20">
          <div className="text-center">
            <h2 className="xl:text-5xl sm:text-4xl text-3xl font-bold text-primaryTextColor mb-4">
              Why Choose Us
            </h2>
            <p className="lg:text-xl text-lg text-gray-600 max-w-2xl mx-auto">
              Experience the difference with our comprehensive real estate
              services designed around your needs
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mt-5">
            {features.map((feature, index) => (
              <div
                key={index}
                className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2"
              >
                <div className="text-4xl mb-4">{feature.icon}</div>
                <h3 className="text-xl font-semibold text-gray-800 mb-3">
                  {feature.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Partners Section */}
      <section className="py-8 bg-white">
        <div className="px-4 sm:px-6 md:px-10 lg:px-12 xl:px-20">
          <div className="text-center mb-7">
            <h2 className="xl:text-5xl sm:text-4xl text-3xl font-bold text-gray-800 mb-4">
              Our Trusted Partners
            </h2>
            <p className="lg:text-xl text-lg text-gray-600 max-w-2xl mx-auto">
              Collaborating with industry leaders to bring you the best
              properties and services
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8 items-stretch">
            {partners.map((partner, index) => (
              <div
                key={index}
                className="flex flex-col bg-gray-50 items-center justify-center p-6 rounded-lg hover:shadow-xl transition-all duration-300"
              >
                <div className="text-4xl mb-3">{partner.logo}</div>
                <h3 className="text-sm font-semibold text-gray-700 text-center">
                  {partner.name}
                </h3>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
